<template lang="pug">
  div
    div(v-if="getCOTCFloading || getCOTCGloading").charts
      ods-row(:gutter=8 type="flex" justify="center" align="middle")
        ods-col(:span="12" v-loading="getCOTCFloading || getCOTCGloading").colminwidth
    div(v-else).charts
      ods-row(:gutter=8 type="flex" justify="center" align="middle")
        ods-col(:span="12" v-for="(item, index) in title" :key="index").colminwidth
          ods-module(:loading-title="title[index]")
            single-pie-chart(:datagraf="data[index]" :title="title[index]" :tag="tag[index]" :colors="colors[index]" :linkTo="linkTo[index]" :totalReal="totalReal[index]")
    div(v-if="getCOTCFloading || getCOTCGloading")
      ods-row(:gutter=8 type="flex" justify="center" align="middle")
        ods-col(:span="12" v-loading="getCOTCFloading || getCOTCGloading").colminwidth
    div(v-else).charts
      ods-row(:gutter=8 type="flex" justify="center" align="middle")
        ods-col(:span="12" v-for="(item, index) in title" :key="index").colminwidth
          ods-module(v-loading="getCOTCFloading || getCOTCGloading" :loading-title="title[index]")
            single-line-chart(:datagraf="dataLine[index]" :title="title[index]" :colors="colors[index]" :tag="tag[index]" :linkTo="linkTo[index]")
</template>

<script>
import Analytics from '@/components/loyalty/Analytics/Analytics'
import SinglePieChart from '@/components/loyalty/Analytics/SinglePieChart'
import SingleLineChart from '@/components/loyalty/Analytics/SingleLineChart'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Analytics',
  components: {
    Analytics,
    'single-pie-chart': SinglePieChart,
    'single-line-chart': SingleLineChart
  },
  data () {
    return {
      fechaHasta: null,
      appProgram: null,
      title: [this.$t('loyalty.analytics.affectedAccounts', { total: 0, totalreal: 0 }), this.$t('loyalty.analytics.regCllients')],
      tag: [this.$t('loyalty.accounts'), this.$t('breadcrumb.clients')],
      linkTo: ['AnalyticsAccounts', 'AnalyticsClients'],
      colors: [
        ['#79C5B4', '#F7AC6F', '#E88AA2'],
        ['#7874B4', '#87BEE6', '#1A3B47']
      ],
      totalReal: [],
      data: [],
      dataLine: []
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    ...mapGetters(['getCOTCGloading', 'getCOTCFloading', 'getLang', 'getFechaHasta', 'getSelectedProgram'])
  },
  methods: {
    ...mapActions(['getCOTCG', 'getCOTCF']),
    async getData () {
      this.getCOTCF().then(respCuentas => {
        // console.log('respCuentas', respCuentas)
        if (respCuentas && respCuentas.retorno === '000' && respCuentas.registros) {
          this.data.push(this.getDataTypePie(respCuentas.registros))
          this.dataLine.push(this.getDataTypeLine(respCuentas.registros))
        } else {
          this.data.push([
            { value: 0, name: this.$t('loyalty.analytics.active') },
            { value: 0, name: this.$t('loyalty.analytics.blocked') },
            { value: 0, name: this.$t('loyalty.analytics.closed') }
          ])
          this.dataLine.push({
            xAxisName: this.$t('noResults'),
            yAxisName: this.$t('loyalty.accounts'),
            xAxis: [],
            lines: [
              { name: this.$t('loyalty.analytics.active'), values: [0, 0, 0, 0, 0, 0, 0] },
              { name: this.$t('loyalty.analytics.blocked'), values: [0, 0, 0, 0, 0, 0, 0] },
              { name: this.$t('loyalty.analytics.closed'), values: [0, 0, 0, 0, 0, 0, 0] }
            ]
          })
        }
        this.getCOTCG().then(respClientes => {
          if (respClientes && respClientes.retorno === '000' && respClientes.registros) {
            this.data.push(this.getDataTypePie(respClientes.registros))
            this.dataLine.push(this.getDataTypeLine(respClientes.registros))
          } else if (respClientes.retorno === 200) {
            this.data.push([
              { value: 0, name: this.$t('loyalty.analytics.women') },
              { value: 0, name: this.$t('loyalty.analytics.men') },
              { value: 0, name: this.$t('loyalty.analytics.noinfo') }
            ])
            this.dataLine.push({
              xAxisName: this.$t('noResults'),
              yAxisName: this.$t('loyalty.analytics.allClients'),
              xAxis: [0, 0, 0, 0, 0, 0, 0],
              lines: [
                { name: this.$t('loyalty.analytics.women'), values: [0, 0, 0, 0, 0, 0, 0] },
                { name: this.$t('loyalty.analytics.men'), values: [0, 0, 0, 0, 0, 0, 0] },
                { name: this.$t('loyalty.analytics.noinfo'), values: [0, 0, 0, 0, 0, 0, 0] }
              ]
            })
            // console.log('respClientes SIN DATOS', respClientes)
          }
        }).catch(err => {
          console.log('catchCOTCG', err)
        })
      }).catch(err => {
        console.log('catchCOTCF', err)
      })
    },
    getDataTypeLine (reg) {
      if (reg && reg.type.match('U9COTCF')) {
        return {
          xAxisName: this.$t('loyalty.analytics.xAxisName', { endDate: reg.fechahasta.valueDate.replaceAll('-', '/') }),
          yAxisName: this.$t('loyalty.accounts'),
          xAxis: [reg.fechadia7, reg.fechadia6, reg.fechadia5, reg.fechadia4, reg.fechadia3, reg.fechadia2, reg.fechadiahoy],
          lines: [
            { name: this.$t('loyalty.analytics.active'), values: [reg.contadordia7c, reg.contadordia6c, reg.contadordia5c, reg.contadordia4c, reg.contadordia3c, reg.contadordia2c, reg.contadordiahoyc] },
            { name: this.$t('loyalty.analytics.blocked'), values: [reg.contadordia7b, reg.contadordia6b, reg.contadordia5b, reg.contadordia4b, reg.contadordia3b, reg.contadordia2b, reg.contadordiahoyb] },
            { name: this.$t('loyalty.analytics.closed'), values: [reg.contadordia7crr, reg.contadordia6crr, reg.contadordia5crr, reg.contadordia4crr, reg.contadordia3crr, reg.contadordia2crr, reg.contadordiahoycrr] }
          ]
        }
      } else {
        // console.log(reg)
        return {
          xAxisName: this.$t('loyalty.analytics.xAxisName', { endDate: reg.fechahasta.valueDate.replaceAll('-', '/') }),
          yAxisName: this.$t('breadcrumb.clients'),
          xAxis: [reg.fechadia7, reg.fechadia6, reg.fechadia5, reg.fechadia4, reg.fechadia3, reg.fechadia2, reg.fechadiahoy],
          lines: [
            { name: this.$t('loyalty.analytics.women'), values: [reg.contadordia7m, reg.contadordia6m, reg.contadordia5m, reg.contadordia4m, reg.contadordia3m, reg.contadordia2m, reg.contadordiahoym] },
            { name: this.$t('loyalty.analytics.men'), values: [reg.contadordia7h, reg.contadordia6h, reg.contadordia5h, reg.contadordia4h, reg.contadordia3h, reg.contadordia2h, reg.contadordiahoyh] },
            { name: this.$t('loyalty.analytics.noinfo'), values: [reg.contadordia7n, reg.contadordia6n, reg.contadordia5n, reg.contadordia4n, reg.contadordia3n, reg.contadordia2n, reg.contadordiahoyn] }
          ]
        }
      }
    },
    getDataTypePie (reg) {
      if (reg && reg.type.match('U9COTCF')) {
        const total = reg.totalcreadas + reg.totalbloqueadas + reg.totalcerradas
        if (reg.totalcuentas !== total) {
          this.tag[0] = this.$t('loyalty.analytics.affectedTotalAccounts', { total: reg.totalcuentas })
          this.totalReal[0] = reg.totalcuentas
        }
        this.title[0] = this.$t('loyalty.analytics.affectedAccounts', { total: total, totalreal: reg.totalcuentas })
        return [
          { value: reg.totalcreadas, name: this.$t('loyalty.analytics.active') },
          { value: reg.totalbloqueadas, name: this.$t('loyalty.analytics.blocked') },
          { value: reg.totalcerradas, name: this.$t('loyalty.analytics.closed') }
        ]
      } else {
        this.totalReal[1] = reg.totalclientes
        return [
          { value: reg.totalmujeres, name: this.$t('loyalty.analytics.women') },
          { value: reg.totalhombres, name: this.$t('loyalty.analytics.men') },
          { value: reg.totalnoinfo, name: this.$t('loyalty.analytics.noinfo') }
        ]
      }
    }
  },
  watch: {
    async getFechaHasta (newData) {
      if (newData) {
        // console.log(`A getFechaHasta ${newData} ${oldData}`)
        this.data = []
        this.dataLine = []
        this.getData()
      }
    },
    async getSelectedProgram (newData, oldData) {
      if (newData) {
        // console.log(`A getSelectedProgram ${newData} ${oldData}`)
        this.data = []
        this.dataLine = []
        this.appProgram = newData
        this.getData()
      }
    },
    getLang (newData) {
      if (newData) {
        const lang = this.getLang.toUpperCase()
        this.$store.commit('SET_LANG', lang)
        this.title = [this.$t('loyalty.accounts'), this.$t('loyalty.analytics.regCllients')]
        this.tag = [this.$t('loyalty.accounts'), this.$t('loyalty.analytics.allClients')]
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss">
.loaddiv {
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
.colminwidth {
  min-height: 10vw;
}
.charts {
  margin: 10px;
}
</style>
